export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-information-line"></i>
            平台介绍
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于8090影院</h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            <div className="text-center p-6 rounded-xl bg-background-100 border border-background-200">
              <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center mb-3">
                <i className="ri-eye-line text-primary-600 text-xl"></i>
              </div>
              <div className="text-2xl font-black text-primary-600 font-heading">500万+</div>
              <div className="text-xs text-foreground-500 mt-1">日均活跃用户</div>
            </div>
            <div className="text-center p-6 rounded-xl bg-background-100 border border-background-200">
              <div className="w-12 h-12 mx-auto rounded-xl bg-accent-100 flex items-center justify-center mb-3">
                <i className="ri-movie-2-line text-accent-600 text-xl"></i>
              </div>
              <div className="text-2xl font-black text-accent-600 font-heading">10000+</div>
              <div className="text-xs text-foreground-500 mt-1">电视剧全集覆盖</div>
            </div>
            <div className="text-center p-6 rounded-xl bg-background-100 border border-background-200">
              <div className="w-12 h-12 mx-auto rounded-xl bg-secondary-100 flex items-center justify-center mb-3">
                <i className="ri-shield-star-line text-secondary-600 text-xl"></i>
              </div>
              <div className="text-2xl font-black text-secondary-600 font-heading">5年</div>
              <div className="text-xs text-foreground-500 mt-1">稳定运营时间</div>
            </div>
          </div>

          <div className="space-y-4 text-foreground-600 text-sm leading-relaxed">
            <p>
              <strong className="text-foreground-900">8090影院</strong>成立于2021年，是专注于华语电视剧高清在线播放的专业平台。我们深知每一位追剧爱好者对画质和流畅度的追求，因此投入大量技术资源，打造了行业领先的智能视频加速系统，确保用户在观看<strong className="text-foreground-900">最新电视剧全集</strong>时获得<strong className="text-foreground-900">影院画质</strong>般的视觉享受。
            </p>
            <p>
              平台内容覆盖悬疑、古装、都市、仙侠、刑侦等全品类剧集，所有资源<strong className="text-foreground-900">同步更新</strong>各大平台首播内容，让您不错过任何一部热门好剧。我们的技术团队7×24小时保障服务稳定，确保<strong className="text-foreground-900">在线不缓冲</strong>的流畅追剧体验。
            </p>
            <p>
              8090影院始终坚持以用户体验为核心，不断优化播放技术和内容更新速度，致力于成为最受信赖的<strong className="text-foreground-900">高清免费追剧</strong>平台。无论是最新上线的大热剧还是经典回顾，这里都是您的追剧首选。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}